import L from "leaflet";

export const leafletURL =
  `https://api.mapbox.com/styles/v1/${window.REACT_APP_LEAFLET_USER}` +
  `/${window.REACT_APP_LEAFLET_ID}/tiles/256/{z}/{x}/{y}?access_token=${window.REACT_APP_LEAFLET_TOKEN}`;

export const googleSatelliteURL = "http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}&s=Ga";

export const getBoundingBox = (boundingBox) => {
  if (
    !boundingBox ||
    !boundingBox.coordinates ||
    !boundingBox.coordinates.length ||
    !boundingBox.coordinates[0].length >= 4
  )
    return L.latLngBounds([
      [42.35, -71.11],
      [42.37, -71.06],
    ]);

  const corner1 = boundingBox.coordinates[0][0];
  const corner2 = boundingBox.coordinates[0][2];

  return L.latLngBounds([
    [corner1[1], corner1[0]],
    [corner2[1], corner2[0]],
  ]);
};

export const getBoundsFromLatLng = (latLng, spread = 0.0015) =>
  L.latLngBounds([
    [latLng.lat - spread, latLng.lng - spread],
    [latLng.lat + spread, latLng.lng + spread],
  ]);
